import React, { useEffect, useState } from 'react'
import { Button, Input, Select, Spin, Table, } from 'antd'
import 'aos/dist/aos.css'
import '../MainCSS.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi'
import { GetItemNameData, GetItemStockReportData,  } from '../../AllAPI/SalesOrderReportAPI/SalesOrderReportApi'
import { Option } from 'antd/es/mentions'
import { DieNameMasterGet } from '../../AllAPI/MasterAPI/DiesMasterApi'

const ItemStock = () => {

   const commonHeaders1 = {
      headers: {
        createdBy: 1,
        updatedBy: 2,
      },
    }
  
     const [errors, setErrors] = useState({
        itemName: '',
        allocationStatus: '',
      })
  
      const [allItemName , setAllItemName ] = useState([])
      const [allItemStockReportData , setAllItemStockReportData ] = useState([])
      const [itemName, setItemName] = useState('')
      const [allocationStatus, setAllocationStatus] = useState('2')
      const [loading, setLoading] = useState(false)
  
        // Fetch Item====
          let isItemFetched = false;
          useEffect(() => {
            if (isItemFetched) return;
            fetchItemName();
            isItemFetched = true;
          }, []);
  
  
       //=========CANCEL SALES ITEM WISE REPORT DATA============
    const handleCancel = () => {
      setItemName('')
      setAllocationStatus('1')
      setErrors('')
      setFilteredData([])
      setAllItemStockReportData([])
    }
      //======================================
        const [pageSize, setPageSize] = useState(10)
        const [filteredData, setFilteredData] = useState([])
        const [currentPage, setCurrentPage] = useState(1)
        const [totalEntries, setTotalEntries] = useState(0)
      
        const handleSearch = (value) => {
          const searchValue = value.toLowerCase()
      
          const filtered = allItemStockReportData.filter((item) =>
            Object.values(item).some((val) =>
              String(val ?? '')
                .toLowerCase()
                .includes(searchValue),
            ),
          )
      
          setFilteredData(filtered)
          setTotalEntries(filtered.length)
          setCurrentPage(1)
        }
        //==========Pagination=======================
        const handlePageSizeChange = (value) => {
          setPageSize(value)
        }
  

    let isError = false;
    
      const columns = [
        {
          title: 'Sr.No.',
          dataIndex: '',
          key: 'index',
          render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
        },
        {
          title: 'Packing Id',
          dataIndex: 'packing_Id',
          key: 'packing_Id',
        },
        {
          title: 'Item Name',
          dataIndex: 'item_name',
          key: 'item_name',
        },
        {
          title: 'Alloy',
          dataIndex: 'alloy_name',
          key: 'alloy_name',
        },
        {
          title: 'Temper',
          dataIndex: 'temper_name',
          key: 'temper_name',
        },
        {
          title: 'Wt Range',
          dataIndex: 'weight_range',
          key: 'weight_range',
        },
        {
          title: 'Length',
          dataIndex: 'length',
          key: 'length',
        },
        {
          title: 'Pcs',
          dataIndex: 'pcs',
          key: 'pcs',
        },
        {
          title: 'Qty',
          dataIndex: 'qty',
          key: 'qty',
        },
        {
          title: 'Dispatch Status',
          dataIndex: 'dispatch_status',
          key: 'dispatch_status',
          render: (status) => {
          if (status === 0) return 'N/A';
          if (status === 1) return 'Sent to Dispatch';
          if (status === 2) return 'Sent to Jobwork';
          return ''; // fallback if needed
        },
        },
        {
          title: 'Allocated To',
          dataIndex: 'customer_name',
          key: 'customer_name',
        },

      ]

      const components = {
        header: {
          cell: ({ children, ...restProps }) => (
            <th
              {...restProps}
              style={{
                backgroundColor: '#023E7D',
                color: '#fff',
                padding: '10px',
                fontSize: '13px',
                borderRadius: '0px',
              }}
            >
              {children}
            </th>
          ),
        },
        body: {
          row: ({ children, ...restProps }) => (
            <tr
              {...restProps}
              style={{
                backgroundColor: '#f0f7fd',
              }}
            >
              {children}
            </tr>
          ),
          cell: ({ children, ...restProps }) => (
            <td
              {...restProps}
              style={{
                padding: '8px',
              }}
            >
              {children}
            </td>
          ),
        },
      }
  
     const fetchItemName = async () => {
      
        try {
          const response = await axios.get(DieNameMasterGet,commonHeaders1);
          if (response.data !== null) {
            setAllItemName(response.data);
          }
        } catch (error) {
          if (!isError) {
            console.error("Error fetching Item Name:", error);
            toast.error("Failed to fetch Item Name data");
            isError = true; // Set the flag to prevent double toast
          }
        }
      };
    //=========GET SALES ITEM WISE REPORT DATA============
      // const handleShowPdf = async () => {
      // let isValid = true
      // const errorObj = {}
  
      //  if (!itemName) {
      //   isValid = false;
      //   errorObj.itemName = "Item Name is required *";
      // }
      //  if (!allocationStatus) {
      //   isValid = false;
      //   errorObj.allocationStatus = "Allocation Status is required *";
      // }
  
      // setErrors(errorObj)
      // if (!isValid) return
  
  
      // try {
      //   const response = await axios.get(`${GetItemStockReportData}?itemName=${itemName}&allocationStatus=${allocationStatus}`, commonHeaders1)
  
      //   if (response.data !== null) {
      //     if (
      //       response.data === 'NOTFOUND' ||
      //       response.data === 'NODATA' ||
      //       response.status === 204
      //     ) {
      //       toast.warn('No data available!', {
      //         position: 'top-right',
      //         autoClose: 2000,
      //         hideProgressBar: false,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //       })
  
      //       setLoading(false)
      //       return // Exit function early
      //     }
    
      //     let reportUrl = response.data
      //     if (reportUrl === 'NOTFOUND') {
      //       toast.warn('Report File Not Found...!!', {
      //         position: 'top-right',
      //         autoClose: 2000,
      //         hideProgressBar: false,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //       })
      //     } else {
      //       const reportLink = BaseIPForPDF + `output/${reportUrl}`
      //       window.open(reportLink, '_blank')
      //     }
      //   }
      // } catch (error) {
      //   setLoading(false)
      //   console.error('Error during API call:', error)
      //   toast.error('Error occurred while submitting data')
      // }
      // }

       const handleShowReport = async () => {

            let isValid = true
            const errorObj = {}
        
            if (!itemName) {
              isValid = false;
              errorObj.itemName = "Item Name is required *";
            }
            if (!allocationStatus) {
              isValid = false;
              errorObj.allocationStatus = "Allocation Status is required *";
            }
  
            setErrors(errorObj)
            if (!isValid) return
      
        try {
            const response = await axios.get(`${GetItemStockReportData}?dieNameId=${itemName}&allocation=${allocationStatus}`, commonHeaders1)

          if (response.data == "NOTFOUND") {
             toast.warn("Data not found!!");
          }
            else if (response.data !== null) {
            setLoading(false);
            setAllItemStockReportData(response.data);
            setFilteredData(response.data)
            setTotalEntries(response.data.length)
          }
        } catch (error) {
          setLoading(false);
          if (!isError) {
            console.error("Error fetching Item Stock Data:", error);
            toast.error("Failed to fetch Item Stock Data");
            isError = true; // Set the flag to prevent double toast
          }
        }
      };
  

  return (
     <>
      <div className="px-5 py-3">
        <div
          className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
          style={{ backgroundColor: '#e0efff' }}
        >
          <div className="col-12">
            <div className="row px-md-5 mt-3 p-2">
                <div className="col-md-6 col-lg-2 py-1"></div>
                  <div className="col-md-6 col-lg-4 py-1">
                    <label className="labels">Item Name</label>
                    <Select
                      value={itemName || undefined}
                      onChange={setItemName}
                      showSearch
                      className="w-100"
                      placeholder="Select Item Name"
                      optionFilterProp="children"
                    >
                      {allItemName.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.dieName}
                        </Option>
                      ))}
                    </Select>
                    {errors.itemName && (
                      <div className="errorField">{errors.itemName}</div>
                    )}
                  </div>
                 <div className="col-md-6 col-lg-4 py-1">
                          <label className="labels">Allocation Status</label>
                          <Select
                            value={allocationStatus}
                            onChange={(value) => setAllocationStatus(value)}
                            showSearch
                            className="w-100"
                            optionFilterProp="children"
                          >
                            <Option value="2">Not Allocated</Option>
                            <Option value="1">Allocated</Option>
                          </Select>
                          {errors.allocationStatus && <div className="errorField">{errors.allocationStatus}</div>}
                        </div>
                <div className="col-md-6 col-lg-2 py-1"></div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleShowReport}
                    disabled={loading}
                  >
                      {loading ? "Generating PDF..." : "View Report"}
                  </Button>
                </div>
            </div>

             {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: 'white' }}
              >

                <div
                  className="col-12 px-md-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      Show entries &nbsp;
                    </span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto' }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default ItemStock